<template>
  <div>
    <template v-if="item.isDiscarded">
      <AppShowPersonName :person="item.discardedByPerson" />
      <div class="hmtt-source-timestamp">
        <span
          v-for="txt in separateDateAndTime(
            $dayjs.date(item.discardedAt, 'fullTime')
          )"
          :key="txt"
        >
          <template v-if="txt === 'icon'">
            <v-icon size="8px" style="position: relative; top: -1px"
              >$iconCircleSmall</v-icon
            >
          </template>
          <template v-else>
            {{ txt }}
          </template>
        </span>
      </div>
    </template>
    <template v-else-if="item.updatedByPerson">
      <AppShowPersonName :person="item.updatedByPerson" />
      <div class="hmtt-source-timestamp">
        <span
          v-for="txt in separateDateAndTime(
            $dayjs.date(item.updatedAt, 'fullTime')
          )"
          :key="txt"
        >
          <template v-if="txt === 'icon'">
            <v-icon size="8px" style="position: relative; top: -1px"
              >$iconCircleSmall</v-icon
            >
          </template>
          <template v-else>
            {{ txt }}
          </template>
        </span>
      </div>
    </template>
    <template v-else>
      <AppShowPersonName :person="item.createdByPerson" />
      <div class="hmtt-source-timestamp">
        <span
          v-for="txt in separateDateAndTime(
            $dayjs.date(item.createdAt, 'fullTime')
          )"
          :key="txt"
        >
          <template v-if="txt === 'icon'">
            <v-icon size="8px" style="position: relative; top: -1px"
              >$iconCircleSmall</v-icon
            >
          </template>
          <template v-else>
            {{ txt }}
          </template>
        </span>
      </div>
    </template>
  </div>
</template>
<script>
import gql from "fraql";
export default {
  name: "HorseMedicalTreatmentSource",
  fragments: {
    horseMedicalTreatmentFields: gql`
      fragment _ on HorseMedicalTreatment {
        isDiscarded
        createdAt
        updatedAt
        discardedAt
        createdByPerson {
          id
          ${AppShowPersonName.fragments.person}
        }
        updatedByPerson {
          id
          ${AppShowPersonName.fragments.person}
        }
        discardedByPerson {
          id
          ${AppShowPersonName.fragments.person}
        }
      }
    `
  }
};
</script>
<script setup>
import AppShowPersonName from "@AppShows/person/AppShowPersonName.vue";

defineProps({
  item: {
    type: Object,
    required: true
  }
});

function separateDateAndTime(timestamp) {
  if (!timestamp) return [];
  let tt = timestamp.split(" ");
  tt.splice(1, 0, "icon");
  return tt;
}
</script>
